<template>
	<div class="bg-transparent small text-uppercase d-block d-sm-flex align-items-center d-lg-none mb-4 justify-content-between">
		<h5 class="m-0 mr-5 mb-3 mb-sm-0" v-if="title">
			{{ title.toUpper() }}
		</h5>
		<div class="d-inline-flex gap-2">
			<b-button variant="outline-secondary" class="w-40 h-40 shadow-sm bg-white"
				@click="$emit('new-button-click')" v-if="isNewButton">
				<span class="d-flex">
					<i class="ri-add-line"></i>
				</span>
			</b-button>
			<b-button variant="outline-secondary" class="w-40 h-40 shadow-sm bg-white"
				@click="$emit('rank-button-click')" v-if="isRankButton">
				<span>
					<i class="ri-sort-desc"></i>
				</span>
			</b-button>
			<b-button variant="outline-secondary" class="w-40 h-40 shadow-sm bg-white"
				@click="$emit('import-button-click')" v-if="isImportButton">
				<span class="d-flex">
					<i class="ri-upload-line"></i>
				</span>
			</b-button>
            <b-button variant="outline-secondary shadow-sm" class="w-40 h-40 shadow-sm bg-white"
                      @click="otherButton.emit ? $emit(otherButton.emit) : ''" v-if="otherButton.show">
                            <span class="d-flex">
                                <i :class="otherButton.icon ? otherButton.icon + ' mr-1' : ''"
                                   v-if="otherButton.icon"></i>
                                <span v-if="otherButton.title">{{ otherButton.title }}</span>
                            </span>
            </b-button>
			<b-dropdown variant="outline-secondary" class="h-40" v-if="isColumns"  toggle-class="shadow-sm bg-white">
				<template #button-content>
					<span class="d-flex">
						<i class="ri-layout-column-line"></i>
					</span>
				</template>
				<div class="checkbox-list width-300">
					<div class="px-4 py-2">
						<slot name="columns"></slot>
					</div>
				</div>
			</b-dropdown>
			<b-button variant="outline-secondary" class="w-40 h-40 shadow-sm bg-white" @click="filterDivStatusHide"
				v-if="isFilter">
				<span>
					<i class="ri-filter-3-line"></i>
				</span>
			</b-button>
			<b-button variant="outline-secondary w-40" class="shadow-sm bg-white" @click="$emit('expand-all')"
				v-if="isExpandAll">
				<span class="d-flex">
					<i class="ri-arrow-down-s-line font-size-20"></i>
				</span>
			</b-button>
			<b-button variant="outline-secondary w-40" class="shadow-sm bg-white" @click="$emit('collapse-all')"
				v-if="isCollapseAll">
				<span class="d-flex">
					<i class="ri-arrow-up-s-line font-size-20"></i>
				</span>
			</b-button>
			<b-button variant="danger" class="w-40 shadow-sm bg-white" @click="$emit('move-cancel')" v-if="isCancelToMove">
				<span class="d-flex">
					<i class="ri-close-line font-size-20"></i>
				</span>
			</b-button>
			<b-dropdown variant="outline-secondary" class="w-40 h-40" toggle-class="shadow-sm bg-white"
				v-if="actions && filteredActions.length > 0">
				<b-dropdown-item v-for="(action, actionKey) in filteredActions" :key="'actionMobile' + actionKey"
					@click="action.callback">
					{{ action.text.toUpper() }}
				</b-dropdown-item>
			</b-dropdown>
			<div class="d-inline-flex" v-if="isBackButton">
				<b-button variant="outline-secondary" class="w-40 h-40 shadow-sm bg-white" @click="backButton">
					<i class="ri-arrow-left-line"></i>
				</b-button>
			</div>
			<template v-for="(button, index) in actionButtons">
				<b-button :variant="button.variant ? button.variant : 'outline-secondary'"
					:key="`action-button-${index}`" class="shadow-sm bg-white" :class="button.class ? button.class : ''"
					@click="button.callback">
					<i v-if="button.icon" :class="button.icon"></i>
					{{ button.text }}
				</b-button>
			</template>
		</div>
	</div>
</template>
<script>

export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		isNewButton: {
			type: Boolean,
			default: false,
		},
		isRankButton: {
			type: Boolean,
			default: false,
		},
		isImportButton: {
			type: Boolean,
			default: false,
		},
		isColumns: {
			type: Boolean,
			default: false,
		},
		isFilter: {
			type: Boolean,
			default: true,
		},
		isExpandAll: {
			type: Boolean,
			default: false
		},
		isCollapseAll: {
			type: Boolean,
			default: false
		},
		isCancelToMove: {
			type: Boolean,
			default: false
		},
		actions: {
			type: Array,
			default: null
		},
		actionButtons: {
			type: Array,
			default: () => []
		},
		isBackButton: {
			type: Boolean,
			default: false,
		},
		backButton: {
			type: Function,
			default: function () {
			}
		},
        otherButton: {
            type: Object,
            default: () => ({
                show: false,
                icon: null,
                title: null,
                emit: null
            })
        },
	},
	data() {
		return {
			filterDivStatus: true,
		}
	},
	computed: {
		filteredActions() {
			let arr = [];
			this.actions.forEach(item => {
				let add = false;
				if (!item.permission || (item.permission && this.checkPermission(item.permission))) {
					add = true;
				}
				if (add && typeof item.show == 'function') {
					add = item.show();
				}
				if (add) {
					arr.push(item);
				}
			})
			return arr;
		}
	},
	mounted() {
		this.$emit("filter:show", this.filterDivStatus);
	},
	methods: {
		filterDivStatusHide() {
			this.filterDivStatus = !this.filterDivStatus;
			this.$emit("filter-div-status", this.filterDivStatus);
		}
	}
}
</script>

